<template>
  <div class="contact_form">
    <div class="thanks_area">
      <p class="thanks_txt">
        お問い合わせありがとうございました。<br>
        後日、担当者よりご連絡をさせていただきますので少々お待ちください。
      </p>
    </div>
    <div class="form_btn"><button class="btn" @click="confirm">top</button></div>
  </div>
</template>

<script>
export default {
  name: 'ThanksTmp',
  data () {
    return {
      msg: 'thanks'
    }
  },
  methods: {
    confirm () {
      console.log(this.msg);
      this.$emit('change-page', 'input')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.contact_form {
  .thanks_area {
    .thanks_txt {
      font-size: 20px;
      text-align: center;
      line-height: 2.0;
    }
  }
  .form_btn {
    margin-top: 30px;
    text-align: center;
    .btn {
      appearance: none;
      min-width: 150px;
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      font-size: 18px;
      &:focus {
        outline: none;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ThanksTmp.vue